<script setup lang="ts">
import { storeToRefs } from 'pinia';

import ComingSoon from '@clovyr/bed/assets/images/coming-soon.svg';
import Opennode from '@clovyr/bed/assets/images/opennode.svg';

import { useUserFlagsStore } from '@/stores/user_flags';

const { isInternal } = storeToRefs(useUserFlagsStore());
</script>

<template>
  <div class="open-node" :class="{ disabled: !isInternal }">
    <div class="open-node__images"><ImageMedia :filename="Opennode" /></div>
    <div class="open-node_text">
      <p class="open-node__heading">Pay via Opennode</p>
      <h4 class="open-node__sub-heading">BTC</h4>
    </div>
    <ImageMedia v-if="!isInternal" class="coming-soon" :filename="ComingSoon" />
  </div>
</template>

<style scoped lang="scss">
@use '@clovyr/bed/styles/vendor/bootstrap/scss/bootstrap';
@use '@clovyr/bed/styles/core';
@use 'src/styles/core/page';
@use 'src/styles/core/vertical-spacing';
@use 'styles/core/colors';
@use 'styles/vendor/bootstrap/scss/mixins/breakpoints';

.open-node {
  height: 7rem;
  width: 350px;
  display: flex;
  padding: 8px 36px;
  margin-bottom: 1rem;
  align-items: center;
  justify-content: center;
  gap: 8px;
  flex: 1 0 0;
  border-radius: 18px;
  border: 1px solid colors.color(grey, secondary);
  background: colors.color(negative, primary);

  @include breakpoints.media-breakpoint-up(md) {
    width: 300px;
    height: 6rem;
    justify-content: flex-start;
  }

  &__images {
    padding: 0.25rem;
  }
  &__text {
    margin-right: 0.5rem;
  }
}

.open-node:hover {
  cursor: pointer;
}

.open-node:hover:not(.disabled) {
  background-color: colors.color(grey, primary);
  border: 1px solid colors.color(grey, primary);
}

.open-node {
  position: relative;
  &__heading {
    font-size: 13px;
  }
  &.disabled {
    opacity: 0.4;
    background: var(--Midnight, #221a33);
  }
}

.coming-soon {
  position: absolute;
  right: -22px;
  bottom: -5px;
}
</style>
